import React from 'react';

const SvgCircleActive = ({ cx, cy, color, mouseEnter, mouseLeave, index }) => {
  const isFirefox = window.navigator.userAgent.includes('Firefox');

  return isFirefox ? (
    <circle
      cx={cx}
      cy={cy}
      r={4}
      fill="#FFF"
      fillRule="evenodd"
      stroke={color}
      strokeLinejoin="square"
      strokeWidth={2}
      onMouseEnter={() => mouseEnter(cx, cy, index)}
      onMouseLeave={() => mouseLeave()}
    />
  ) : (
    <svg
      cx={cx}
      cy={cy}
      x={cx - 9}
      y={cy - 9}
      fill={color}
      width={18}
      height={18}
      onMouseEnter={() => mouseEnter(cx, cy, index)}
      onMouseLeave={() => mouseLeave()}
    >
      <defs>
        <filter
          id="circleActive_svg__a"
          width="220%"
          height="220%"
          x="-60%"
          y="-60%"
          filterUnits="objectBoundingBox"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation={2}
          />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.82745098 0 0 0 0 0.337254902 0 0 0 0 0.211764706 0 0 0 0.5 0"
          />
        </filter>
        <circle id="circleActive_svg__b" cx={265} cy={56.876} r={5} />
      </defs>
      <g fill="none" transform="translate(-256 -48)">
        <use
          fill="#000"
          filter="url(#circleActive_svg__a)"
          xlinkHref="#circleActive_svg__b"
        />
        <circle
          cx={265}
          cy={56.876}
          r={4}
          fill="#FFF"
          fillRule="evenodd"
          stroke={color}
          strokeLinejoin="square"
          strokeWidth={2}
        />
      </g>
    </svg>
  );
};

export default SvgCircleActive;
